import { render, staticRenderFns } from "./SummaryTransformerInfo.vue?vue&type=template&id=12e71a37&scoped=true&"
import script from "./SummaryTransformerInfo.vue?vue&type=script&lang=js&"
export * from "./SummaryTransformerInfo.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTransformerInfo.vue?vue&type=style&index=0&id=12e71a37&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e71a37",
  null
  
)

export default component.exports